/*
 * @Description: 商机相关api
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-06-21 16:21:35
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-08-02 14:31:23
 */
import { BaseService } from './base-service';
class OpportunityService extends BaseService {
  /**
   * @description: 查询客户
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  relatedCustomer(data) {
    return this.request({
      method: 'get',
      url: `/customer/related/list`,
      params: data
    });
  }
  /**
   * @description: 商机列表--关联客户
   * @param {*} data
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  relateCustomer(data) {
    return this.request({
      method: 'get',
      url: `/opportunity/relate/customer`,
      params: data
    });
  }
  /**
   *  商机详情---商机阶段
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof setService
   */
  getEntityStage(params) {
    return this.request({
      method: 'get',
      url: `/stageProcess/entityStage`,
      params
    });
  }
  /**
   * @description: 新增云文档
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  addCloudDocument(data) {
    return this.request({
      method: 'post',
      url: `/cloud/document/add`,
      data
    });
  }

  /**
   * @description: 新增云文档列表
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getCloudDocument(data) {
    return this.request({
      method: 'post',
      url: `/cloud/document/list`,
      data
    });
  }
  /**
   * @description: 删除云文档/附件
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  deleteDocument(data) {
    return this.request({
      method: 'get',
      url: `/cloud/document/delete`,
      params: data
    });
  }
  /**
   * @description: 文档类型
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getDocumentTypeList(data) {
    return this.request({
      method: 'post',
      url: `/enum/list`,
      data
    });
  }
  /**
   *  商机详情---商机阶段
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  doneTask(data) {
    return this.request({
      method: 'post',
      url: `/stageProcess/doneTask`,
      data
    });
  }
  /**
   *  商机详情---商机阶段---提交审批
   *
   * @author zhaolun
   * @param  {Object} data
   * @returns
   * @memberof opportunityService
   */
  approveTask(data) {
    return this.request({
      method: 'POST',
      url: `/stageProcess/doneTask/approve`,
      data
    });
  }
  /**
   *  商机详情---商机阶段---完成审批任务
   *
   * @author zhaolun
   * @param  {Object} data
   * @returns
   * @memberof opportunityService
   */
  doneApproveTask(params) {
    return this.request({
      method: 'GET',
      url: `/stageProcess/doneTask/task`,
      params
    });
  }
  /**
   *  商机详情--推进至下一阶段
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @returns
   * @memberof setService
   */
  stageProcessAdvance(data) {
    return this.request({
      method: 'post',
      url: `/stageProcess/advance`,
      data
    });
  }
  /**
   * @description: 业绩参与人列表
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getStageWeights(data) {
    return this.request({
      method: 'post',
      url: `/stageWeights/list`,
      data
    });
  }
  /**
   * @description: 新增/编辑业绩参与人
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  updateStageWeights(data) {
    return this.request({
      method: 'post',
      url: `/stageWeights/addOrUpdate`,
      data
    });
  }
  /**
   * @description: 删除业绩参与人
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  deleteStageWeights(data) {
    return this.request({
      method: 'get',
      url: `/stageWeights/delete`,
      params: data
    });
  }
  /**
   * @description: 业绩参与人--角色列表
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getRolesList(data) {
    return this.request({
      method: 'get',
      url: `/stageWeights/roles`,
      params: data
    });
  }
  /**
   * @description: 业绩参与人--阶段列表下拉
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getStagesList(data) {
    return this.request({
      method: 'get',
      url: `/stageWeights/stages`,
      params: data
    });
  }
  /**
   * @description: 线索转化记录
   * @return {*}
   * @author: 胡彩丽 hucaili@qfei.cn
   */
  getClueList(data) {
    return this.request({
      method: 'post',
      url: `/clue/getClueChange`,
      data
    });
  }
  /**
   *  在商机详情中报价单--新建报价单判断商机关联的客户是否有协作权限
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof opportunityService
   */
  getCustomPermission(params) {
    return this.request({
      method: 'get',
      url: `/price_sheet/addPriceSheetRoleCheck`,
      params
    });
  }
  /**
   *  商机作废--作废前校验 是否允许作废
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param
   * @returns
   * @memberof opportunityService
   */
  opportunityCheck(params) {
    return this.request({
      method: 'get',
      url: `/opportunity/check`,
      params
    });
  }
  /**
   *  商机作废--作废
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param
   * @returns
   * @memberof opportunityService
   */
  deleteOpportunity(params) {
    return this.request({
      method: 'get',
      url: `/opportunity/delete`,
      params
    });
  }

  /**
   * @description: 商机名称字段唯一性检查
   * @param {*} data
   * @return {*}
   * @author: 纪楠楠 jinannan@qfei.cn
   */
  opportunityCheckFieldRepeat(data) {
    return this.request({
      method: 'post',
      url: `/opportunity/checkFieldRepeat`,
      data
    });
  }
}
export const opportunityService = new OpportunityService();
